import { render, staticRenderFns } from "./DisplayVariants.vue?vue&type=template&id=4e10f313&scoped=true&"
import script from "./DisplayVariants.vue?vue&type=script&lang=js&"
export * from "./DisplayVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10f313",
  null
  
)

export default component.exports